import {
  AssignableRecipientPagedList,
  AssignableRecipientPagedListResponse,
  RecipientAssignableListParams,
} from '@apiContract';
import isEqual from 'lodash/fp/isEqual';

import { receivedDigitalApi } from './index';

const recipientApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssignableRecipients: builder.query<AssignableRecipientPagedList, RecipientAssignableListParams>({
      query: (params) => ({
        url: 'Recipient/assignable',
        params,
      }),
      transformResponse: (response: AssignableRecipientPagedListResponse) => response.objectData,
    }),
    infiniteLoaderAssignableRecipients: builder.query<AssignableRecipientPagedList, RecipientAssignableListParams>({
      query: (params) => ({
        url: 'Recipient/assignable',
        params,
      }),
      serializeQueryArgs: ({ queryArgs }) => {
        const { PageNumber, ItemsPerPage, ...filters } = queryArgs;
        return JSON.stringify(filters);
      },
      merge: (currentCache, newItems, { arg }) => {
        if (arg.PageNumber === 0) {
          return newItems;
        }

        return {
          ...newItems,
          items: [...(currentCache.items || []), ...(newItems.items || [])],
        };
      },
      providesTags: ['UsersInfinite'],
      transformResponse: (response: AssignableRecipientPagedListResponse) => response.objectData,
      forceRefetch: ({ currentArg, previousArg }) => {
        if (currentArg?.PageNumber !== previousArg?.PageNumber) {
          return true;
        }

        const { PageNumber: currPage, ...currRest } = currentArg || {};
        const { PageNumber: prevPage, ...prevRest } = previousArg || {};

        return !isEqual(currRest, prevRest);
      },
    }),
  }),
});

export const { useGetAssignableRecipientsQuery, useInfiniteLoaderAssignableRecipientsQuery } = recipientApi;
